import { useEffect } from "react";

/**
 * AuthLayout — full-bleed photo background for Login / Forgot / Reset only.
 * Toggles `body.bg-photo` while mounted so the aurora blobs + mint-cream
 * gradient are neutralised on the auth routes and the photo is not competing
 * with them. Content sits above two fixed layers: the image + a dark scrim.
 */
export default function AuthLayout({ children, testId }) {
    useEffect(() => {
        document.body.classList.add("bg-photo");
        return () => {
            document.body.classList.remove("bg-photo");
        };
    }, []);

    return (
        <div className="auth-page" data-testid={testId}>
            <div className="auth-bg" aria-hidden>
                <div
                    className="auth-bg-image"
                    style={{ backgroundImage: "url('/login-bg.jpg')" }}
                />
                <div className="auth-bg-scrim" />
            </div>
            <div className="auth-content">{children}</div>
        </div>
    );
}
